import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import Icon from '@mdi/react';
import { mdiPlus, mdiFlagVariantOutline, mdiChartBoxOutline, mdiFileTree, mdiBellOutline } from '@mdi/js';
import classes from '../../api/classes';
import { MoreMenu, MenuItem } from '../MoreMenu/MoreMenu';
import SidePopout from '../SidePopout';
import EventForm, { initialFormData } from '../EventForm';
import { useToast } from '../../hooks/useToast';

const { Event } = classes;

export function CreateMenu() {
	const [eventTags, setEventTags] = useState([]);
	const [eventFormOpen, setEventFormOpen] = useState(false);
	const [newEvent, setNewEvent] = useState(initialFormData);
	const [, showToast] = useToast();

	useEffect(() => {
		const fetchEvents = async () => {
			const fetchedEvents = await Event.fnCache.getEvents();
			setEventTags(_.uniq(fetchedEvents.map((event) => event.tags).flat().reverse()));
		};
		fetchEvents();
		setNewEvent(initialFormData);
	}, [eventFormOpen]);

	return (
		<>
			<MoreMenu icon={<Icon path={mdiPlus} />}>
				<MenuItem
					icon={<Icon path={mdiChartBoxOutline} />}
					href="/reports"
					hrefState={{ new: true }}
				>New report</MenuItem>
				<MenuItem
					icon={<Icon path={mdiFlagVariantOutline} />}
					onClick={() => setEventFormOpen(true)}
				>New event</MenuItem>
				<MenuItem
					icon={<Icon path={mdiBellOutline} />}
					href="/alarms?autoExpand=new_alarm"
				>New alarm</MenuItem>
				<MenuItem
					icon={<Icon path={mdiFileTree} />}
					href="/settings/programmatic-configurations"
				>New integration</MenuItem>
			</MoreMenu>
			<SidePopout open={eventFormOpen}>
				<EventForm
					data={newEvent}
					availableTags={eventTags}
					onSubmit={async (updatedEvents, actionType) => {
						setEventTags(_.uniq(updatedEvents.map((event) => event.tags).flat().reverse()));
						setEventFormOpen(false);
						showToast({
							message: `Event ${actionType === 'add' ? 'added' : 'updated'}.`,
							status: 'success',
							timeout: 6,
						});
					}}
					onFormDataChange={(data) => setNewEvent(data)}
					onClose={() => setEventFormOpen(false)}
				/>
			</SidePopout>
		</>
	);
}
